import { render } from "./ResellerManage.vue?vue&type=template&id=af5eddd6"
import script from "./ResellerManage.vue?vue&type=script&lang=js"
export * from "./ResellerManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__